import { useCallback, useEffect, useMemo, useRef, useState } from "react"

import {
  Alert,
  App,
  Carousel,
  Divider,
  Flex,
  Modal,
  Pagination,
  Segmented,
  Space,
  Typography
} from "antd"
import { useTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import Button from "../../Components/Button"
import EmptyComponent from "../../Components/Empty"
import ExportDropdown from "../../Components/Export"
import FilterCard from "../../Components/FilterCard"
import Filters from "../../Components/Filters"
import GlobalFilterTestData from "../../Components/GlobalFilterTestData/globalFilterTest"
import ListViewToggle from "../../Components/ListViewToggle/ListViewToggle"
import ManageColumn from "../../Components/ManageColumns"
import MobilePagination from "../../Components/MobilePagination/MobilePagination"
import Table, { itemRender } from "../../Components/Table"
import { getBaseColumns } from "../../Components/Table/baseColumns"
import { useTitleSectionAction } from "../../Components/TitleSection/TitleSectionContext"
import TourComponent from "../../Components/Tour"
import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Icon from "../../Icon"
import Images from "../../Images"
import { modalConfig } from "../../theme"
import { adminRoleId, extendedAccessRoles } from "../../Utils/permission"
import { getTourEl, serializeData } from "../../Utils/utils"
import GlobalCreators from "../GlobalFilters/reducer"
import { useDemoDataToggle } from "../User/hooks/useDemoDataToggle"
import { setDemoTourStep } from "../User/redux/user.actions"
import { getEnrollments, getPaymentProcessors, userSave } from "../User/redux/user.thunks"
import { AlertDrawer } from "./components/Drawer"
import AlertsList from "./components/List/AlertsList"
import { getActionColumn, getColumns, getDefaultColumn } from "./components/Table/columns"
import useBulkAction from "./hooks/useBulkAction"
import Creators, { selectAreFiltersDefault } from "./reducer"
import { useAlertsPageQuery } from "./useAlertsPageQuery"

import "./styles.less"

// import TransactionModal from '../../Components/Modal/TransactionModal'
// import { useAlertStatusTransactionFlow } from './hooks/useAlertStatusTransactionFlow'

const statisticData = [
  {
    id: "all",
    name: "All",
    brand: null,
    value: 0,
    isConnected: true
  },
  {
    id: "Ethoca",
    name: "Ethoca",
    img: "ethoca",
    brand: "mastercard",
    value: 0,
    isConnected: false
  },
  {
    id: "RDR",
    name: "RDR",
    img: "rdr",
    brand: "visa",
    value: 0,
    isConnected: false
  },
  {
    id: "CDRN",
    name: "CDRN",
    img: "cdrn",
    brand: "visa",
    value: 0,
    isConnected: false
  }
]

const pageSize = 50
const initialTableRowsCount = 15
const initialTableColumnsCount = 5

const optionsVisibility = [
  { value: "all", label: "All" },
  { value: "true", label: "Only user" },
  { value: "false", label: "Only admin" }
]

const userOptionsBillable = [
  { value: "all", label: "All" },
  { value: "true", label: "Billable" },
  { value: "false", label: "Non-Billable" }
]

const { Title, Text, Link } = Typography

const AlertsPage = ({
  usersViewForAdmin,
  nav: { isMobile, theme },
  isAdmin,
  businessAccountId,
  roleId,
  ba_role,
  is_demo,
  visibleFiltersUser,
  visibleFiltersAdmin,
  defaultColumns,
  defaultColumnsAdmin,
  columns,
  showRdrPopUp,
  columnsAdmin,
  fetching,
  result,
  filters,
  filterOptions,
  test_data,
  exportFetching,
  exportResult,
  saveResult,
  transactionModalSaving,
  transactionModalError,
  enrollments,
  demoTourStep,
  currentBusinessAccountId,
  alertsViewMode,
  setAlertsViewMode,
  ...props
}) => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { business_account_id } = useAlertsPageQuery(search)
  const { t } = useTranslation()
  const { notification, modal } = App.useApp()
  const externalDemoMode = useExternalDemoMode()
  const { setAction } = useTitleSectionAction()

  //const [selectEnrollment, setSelectEnrollment] = useState('all')
  const [pageNumber, setPageNumber] = useState(1)
  const [ordering, setOrdering] = useState(null)
  // showRdrPopUp is a backend flag ("this account just had its first RDR alert prevented"),
  // but it can be stale for an account that currently has zero RDR alerts (e.g. RDR was
  // enabled/disabled again) - only actually show the modal once `statistics.rdr` (the same
  // count the RDR FilterCard below reads) confirms there's really at least one.
  const [isRdrModalVisible, setIsRdrModalVisible] = useState(false)
  const [isBackgroundReady, setIsBackgroundReady] = useState(false)
  const [isTableEnhanced, setIsTableEnhanced] = useState(false)
  const [isTableFullyRendered, setIsTableFullyRendered] = useState(false)
  const [activeAlertsViewMode, setActiveAlertsViewMode] = useState(alertsViewMode)
  const effectiveViewMode = isMobile ? "cards" : activeAlertsViewMode

  const isFiltersDefault = useSelector(selectAreFiltersDefault)
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const paymentProcessors = useSelector((state) => state.user.paymentProcessors)

  const { count, results, statistics, count_not_demo } = result

  useEffect(() => {
    if (showRdrPopUp && statistics?.rdr > 0) setIsRdrModalVisible(true)
  }, [showRdrPopUp, statistics?.rdr])

  const isAdminPage = isAdmin && !usersViewForAdmin
  const isDemo = isAdmin && usersViewForAdmin ? businessAccount?.["is_demo"] : is_demo

  const myColumns = isAdminPage ? columnsAdmin : columns
  const allFilters = isAdminPage ? defaultColumnsAdmin : defaultColumns
  const visibleFilters = isAdminPage ? visibleFiltersAdmin : visibleFiltersUser
  const businessAccountRole = isAdmin ? null : ba_role

  const adminParams = usersViewForAdmin ? { business_account_id } : {}

  const myColumnsLength = myColumns.filter(({ active }) => active).length
  const myColumnsHash = myColumns
    .filter(({ active }) => active)
    .map(({ field_id }) => field_id)
    .join("")
  const isDemoModeBlocked = !currentBusinessAccountId

  const notificationConfig = {
    closeIcon: <Text>{t("Dismiss")}</Text>,
    style: { minWidth: "max-content", width: 475 }
  }

  //TODO: CHA-6795
  // const getAlertById = useCallback((alertId) => {
  //   return result?.results?.find((item) => item?.alert_id === alertId) || null
  // }, [result?.results])

  //TODO: CHA-6795
  // const transactionModalProcessors = useMemo(
  //   () => paymentProcessors
  //     ?.filter((processor) => processor?.is_active && processor?.is_connected)
  //     ?.map((processor) => processor?.service_name)
  //     ?.filter(Boolean) || [],
  //   [paymentProcessors]
  // )
  //TODO: CHA-6795
  // const canOpenTransactionModal = useMemo(
  //   () => transactionModalProcessors.some((processor) => processor !== 'manual_refunds'),
  //   [transactionModalProcessors]
  // )
  // const {
  //   transactionModalAlert,
  //   openTransactionModal,
  //   closeTransactionModal,
  //   submitAlertStatusChange,
  //   saveTransactionModalData,
  //   transactionModalInitialValue,
  // } = useAlertStatusTransactionFlow({
  //   onStatusUpdate: props.updateAlert,
  //   onTransactionSave: props.updateAlertTransaction,
  //   getAlertById,
  //   onClearTransactionError: props.clearTransactionModalError,
  //   canOpenTransactionModal,
  // })

  useEffect(() => {
    if (!businessAccountId) return

    props.getPaymentProcessors({
      integrationsPage: true,
      merchant_id: businessAccountId
    })
  }, [businessAccountId, props.getPaymentProcessors])

  useEffect(() => {
    document.title = "Alerts - Chargeback"
  }, [])

  useEffect(() => {
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(() => {
        setIsBackgroundReady(true)
      })

      return () => window.cancelIdleCallback(idleId)
    }

    const timer = setTimeout(() => {
      setIsBackgroundReady(true)
    }, 0)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (alertsViewMode !== "table" && !isBackgroundReady) return

    setIsTableEnhanced(false)
    setIsTableFullyRendered(false)
    const timer = setTimeout(() => {
      setIsTableEnhanced(true)
      setIsTableFullyRendered(true)
    }, 0)

    return () => clearTimeout(timer)
  }, [
    alertsViewMode,
    isBackgroundReady,
    pageNumber,
    ordering,
    filters,
    test_data,
    businessAccountId,
    results
  ])

  useEffect(() => {
    setActiveAlertsViewMode(alertsViewMode)
  }, [alertsViewMode])

  useEffect(() => {
    if (pageNumber !== 1) setPageNumber(1)
    props.getAlertsStatistics(adminParams)
    props.getAlertsFilterOptions(adminParams)
    props.getEnrollments(businessAccountId)
  }, [businessAccountId])

  const updateData = () => {
    const serializeFilters = serializeData(filters)
    const defaultColumns = [
      "_id",
      "pinned",
      "user_error_message",
      "alert_status",
      "alert_timestamp",
      "brand",
      "alert_type",
      "currency",
      "converted_currency",
      "converted_amount",
      "transaction_link",
      "auth_code",
      "transaction_timestamp",
      "arn",
      "card_last4",
      "card_bin",
      "transaction_url",
      "alert_service",
      "amount",
      "payment_processor",
      "is_card_potentially_tokenized",
      "transaction_added_by_user_icon"
    ]

    const defaultColumnsAdmin = [...defaultColumns, "error_message"]
    const columns = myColumns.filter(({ active }) => active).map(({ field_id }) => field_id)

    const adminFilters = {
      billable: null
    }

    const usersViewForAdminFilters = {
      user_visibility: null
    }

    const data = {
      page: pageNumber,
      page_size: pageSize,
      ...adminParams,
      ordering,
      //...(selectEnrollment !== 'all' && {alert_service: selectEnrollment}),
      ...serializeFilters,
      ...(usersViewForAdmin && usersViewForAdminFilters),
      ...(isAdminPage && !usersViewForAdmin && adminFilters),
      ...(isAdminPage ? { test_data } : {}),
      ...(columns.length && {
        columns: [
          ...(isAdminPage ? defaultColumnsAdmin : defaultColumns),
          ...columns,
          "card_bin", //first 6 digits of the card
          "enabled_for_bulk"
        ].join(",")
      })
    }

    props.getAlerts({ ...data })
  }

  const prevTestDataRef = useRef(test_data)

  const {
    isBulkActionActive,
    isBulkActionEnabled,
    rowSelection,
    bulkStatusUpdateDisabled,
    isBulkActionDisabled,
    onBulkAction,
    onBulkStatusUpdate,
    cancelBulkAction
  } = useBulkAction({
    currentPageData: results,
    businessAccount,
    businessAccountId,
    baRole: businessAccountRole,
    isAdmin,
    updateAlerts: updateData
  })

  const { isShowDemoData } = useDemoDataToggle()

  useEffect(() => {
    const testDataChanged = prevTestDataRef.current !== test_data
    if (testDataChanged) {
      prevTestDataRef.current = test_data
      if (pageNumber !== 1) {
        setPageNumber(1)
        return
      }
    }

    updateData()
    //myColumns
  }, [businessAccountId, ordering, pageNumber, filters, test_data, myColumnsLength, isShowDemoData])

  useEffect(() => {
    if (exportResult) {
      notification.success({
        message: t("Exporting"),
        description: exportResult?.message, //t('Your alerts will be downloaded shortly.'),
        ...notificationConfig
      })
      props.clearExportResult()
    }
  }, [exportResult])

  useEffect(() => {
    if (
      [
        "pin",
        "alert_details_export",
        "ticket_create",
        "alert_update",
        "alert_transaction_update"
      ]?.includes(saveResult)
    ) {
      if (saveResult === "pin") {
        updateData()
      } else if (saveResult === "alert_details_export") {
        notification.success({
          message: t("Your alert has been successfully downloaded."),
          ...notificationConfig
        })
      } else if (saveResult === "ticket_create") {
        notification.success({
          message: t("Support ticket submitted"),
          description: t(
            "Thank you for reaching out! Your support ticket has been created successfully. The support team will contact you shortly to assist."
          ),
          ...notificationConfig,
          style: { minWidth: 475, width: 475 }
        })
      } else if (saveResult === "alert_update") {
        props.getAlertsStatistics(adminParams)
      }
      // TODO: CHA-6795
      // else if (saveResult === 'alert_transaction_update') {
      //   notification.success({
      //     message: t('Transaction data saved'),
      //     description: t('Transaction ID has been saved successfully.'),
      //     ...notificationConfig,
      //   })
      //   closeTransactionModal()
      // }
      props.saveResultReset()
    }
  }, [adminParams, notification, props.getAlertsStatistics, props.saveResultReset, saveResult, t])

  const tableSettings = useMemo(
    () => ({
      scroll: {
        //x: (220 * myColumns.filter(({active}) => active).length),
        x: "max-content",
        y: "calc(100vh - 72px - 24px - 32px - 24px - 43px - (16px + 32px + 16px))",
        scrollToFirstRowOnChange: true
      },
      pagination: {
        total: count,
        current: pageNumber,
        pageSize: pageSize
      },
      locale: {
        emptyText: !statistics?.all ? (
          <EmptyComponent type={isAdmin ? "alerts_admin" : "alerts"} />
        ) : (
          <EmptyComponent type={isAdmin ? "alerts_admin" : "search"}>
            <Button
              className="flex"
              icon={<Icon type={"menu_search"} />}
              onClick={props.clearAlertsFilters}
            >
              {t("Clear search")}
            </Button>
          </EmptyComponent>
        )
      }
    }),
    [myColumnsLength, count, pageNumber, statistics]
  )

  const changeStatusConfirm = ({ alert, newStatus }) => {
    modal.confirm({
      ...modalConfig("info"),
      centered: !isMobile,

      title: t("Alert status"),
      content: (
        <>
          <Text type="secondary">{t("Are you sure you want to change alert status?")}</Text>
          <br />
          <Text type="secondary">{t("Changing your alert status is an irreversible action.")}</Text>
        </>
      ),
      cancelText: t("Go back"),
      okText: t("Change status"),
      cancelButtonProps: { size: "large" },
      okButtonProps: { size: "large" },
      onOk() {
        //TODO: CHA-6795
        // submitAlertStatusChange({alert, newStatus})
        props.updateAlert({ alert_id: alert?.alert_id, alert_status: newStatus })
      }
    })
  }

  const handleChangeStatus = ({ newStatus, record }) => {
    changeStatusConfirm({ alert: record, newStatus })
  }

  const getTableColumns = useMemo(() => {
    let options = filterOptions?.["alert_status"] || []

    let allColumns = {
      ...getBaseColumns({ t, isAdmin: isAdminPage, onSelectRow: handleSelectRow }),
      ...getColumns({
        t,
        options,
        handleChangeStatus,
        theme,
        isAdmin: isAdminPage,
        onSelectRow: handleSelectRow,
        disabledStatus: businessAccountRole && !extendedAccessRoles?.includes(businessAccountRole),
        isDemo,
        //TODO: CHA-6795
        // onOpenTransactionModal: canOpenTransactionModal ? openTransactionModal : null,
        onOpenTransactionModal: null
      })
    }

    return [
      allColumns["icon"],
      allColumns["alert_status"],
      ...myColumns
        .filter(({ active }) => active)
        .map((data) => allColumns?.[data.field_id] || getDefaultColumn({ ...data, t })),
      getActionColumn({ onSelectRow: handleSelectRow })
    ]
  }, [
    businessAccountRole,
    filterOptions,
    handleSelectRow,
    isAdminPage,
    isDemo,
    myColumns,
    myColumnsHash,
    t,
    theme
  ])

  const displayedTableColumns = useMemo(() => {
    if (isTableEnhanced || isBackgroundReady) return getTableColumns

    const normalizeValue = (value) => {
      if (value === null || value === undefined || value === "") return "—"
      if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "—"
      if (typeof value === "object") return "—"
      return value
    }

    return getTableColumns
      .filter((column) => !["action", "icon"].includes(column?.key))
      .slice(0, initialTableColumnsCount)
      .map((column) => {
        const { fixed, render, ...baseColumn } = column

        return {
          ...baseColumn,
          render: (value, record) => normalizeValue(record?.[column?.dataIndex] ?? value)
        }
      })
  }, [getTableColumns, isBackgroundReady, isTableEnhanced])

  const displayedTableData = useMemo(() => {
    if (isTableFullyRendered) return results
    return results?.slice(0, initialTableRowsCount) ?? []
  }, [results, isTableFullyRendered])

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    setPageNumber(pagination.current)
    setOrdering(ordering)
  }, [])

  const handleChangeFilter = useCallback(
    (newData, type) => {
      if (newData?.user_email) {
        if (Array.isArray(newData.user_email) && newData.user_email.length > 0) {
          newData.user_email.forEach((email) => {
            if (email) props.addGlobalFilter("user_email", email.trim())
          })
        } else if (typeof newData.user_email === "string" && newData.user_email.trim()) {
          props.addGlobalFilter("user_email", newData.user_email.trim())
        } else {
          props.removeGlobalFilter("user_email")
        }
      }
      if (type === "changeVisible") {
        props.changeVisibleFilters(isAdminPage ? "visibleFiltersAdmin" : "visibleFilters", newData)
      } else {
        props.changeFilters(newData)
        setPageNumber(1)
      }
    },
    [isAdminPage]
  )

  const onClear = useCallback(() => {
    props.clearAlertsFilters()
    props.clearGlobalFilters()
  }, [])

  const handleChangeColumns = useCallback(
    (newColumns) => {
      props.changeColumns(isAdminPage ? "columnsAdmin" : "columns", newColumns)
    },
    [isAdminPage]
  )

  const handleSelectEnrollment = (enrollment) => {
    let newAlertService = null
    if (enrollment === "all") {
      newAlertService = "all"
    } else {
      const currentAlertService = filters?.alert_service || []
      if (currentAlertService === "all") {
        newAlertService = [enrollment]
      } else {
        if (currentAlertService?.includes(enrollment)) {
          newAlertService = currentAlertService.filter((item) => item !== enrollment)
        } else {
          newAlertService = [...currentAlertService, enrollment]
          if (newAlertService?.length === statisticData.length - 1) newAlertService = "all"
        }
      }
    }
    handleChangeFilter({ alert_service: newAlertService })
  }

  const openAlertDetails = (alertData) => {
    if (alertData?.alert_id) {
      if (usersViewForAdmin && search) {
        navigate(`${search}&open_alert=${alertData?.alert_id}`)
      } else {
        navigate(`?open_alert=${alertData?.alert_id}`)
      }
    }
  }

  function handleSelectRow(data, type) {
    //props.changeBusinessAccount(newBusinessAccountId)
    let business_account_id =
      data?.business_account?.business_account_id || data?.business_account?.id
    if (type === "business_account") {
      if (business_account_id) {
        window.open(
          `${process.env.REACT_APP_BASE_URI}/business_settings/enrollment?${new URLSearchParams({ business_account_id })}`
        )
      }
      //setRedirect('/business_settings/my_business')
    } else if (type === "dashboard") {
      navigate(`/admin/dashboard?business_account_id=${business_account_id}`)
    } else if (type === "pin") {
      props.pinAlert({ id: data?.["_id"], pin: !data?.pinned })
    } else if (type === "view_details") {
      openAlertDetails(data)
    }
  }
  const handleExport = useCallback(
    (type) => {
      if (isAdminPage && roleId === adminRoleId && count > 1000) {
        notification.error({
          message:
            "Export is limited to 1,000 alerts per file. Apply filters to narrow the results.",
          ...notificationConfig
        })
        return
      }

      const serializeFilters = serializeData(filters)
      if (businessAccountId || isAdminPage)
        props.getAlertsExport({
          isAdmin: isAdminPage,
          business_id: businessAccountId,
          file_name: isAdminPage
            ? "Alerts report"
            : `Alerts report (businessId_${businessAccountId})`,
          ...(type !== "all" && serializeFilters),
          ...(isAdminPage && type !== "all" ? { test_data } : {})
        })
    },
    [filters, businessAccountId, test_data, roleId, count]
  )

  const handleModalClose = () => {
    setIsRdrModalVisible(false)
    props.updateUser({ set_is_rdr_popup_shown: false })
  }

  const steps = useMemo(
    () => [
      {
        title: (
          <Text type="secondary">
            Keep an eye on alerts in real time with access to all the important details.
          </Text>
        ),
        target: () => getTourEl("alerts-nav")
      },
      {
        title: <Text type="secondary">Check out all details for this alert</Text>,
        target: () => getTourEl("alert-details"),
        nextButtonProps: {
          onClick: () => {
            const alertId = result?.results?.[0]?.alert_id
            if (!alertId) return props.setDemoTourStep(4)
            navigate(`?open_alert=${alertId}`)
            props.setDemoTourStep(3)
          },
          children: <text>Next</text>
        }
      }
    ],
    [navigate, result]
  )

  const handleSetAlertsViewMode = useCallback((mode) => {
    setActiveAlertsViewMode(mode)
    setAlertsViewMode(mode)
  }, [])

  useEffect(() => {
    if (!isMobile || isAdmin) return
    setAction(
      <div style={{ position: "relative" }}>
        <ExportDropdown
          loading={exportFetching}
          onExport={(type) => handleExport(type)}
          isAdmin={isAdminPage}
          disabled={isDemo}
          exportAsFiltered={true}
          iconButton={true}
          inHeader={true}
        />
      </div>
    )
    return () => setAction(null)
  }, [isMobile, isAdmin, exportFetching, handleExport, isAdminPage, isDemo])

  return (
    <Flex className={"alerts-page"} gap={24} vertical>
      {result?.["attention_list"]?.length && !isDemo && !externalDemoMode ? (
        <Alert
          type="warning"
          className="fullscreen-alert"
          showIcon
          icon={<Icon type={"bell_alarm"} />}
          message={
            <>
              {t(
                'There are alerts marked with "Attention" status that have not been auto-refunded. Please review them in the table below and address them manually.'
              )}
              <Link
                onClick={() => handleChangeFilter({ alert_status: ["Attention"] })}
                strong
                style={{ marginLeft: 8, zIndex: 2, position: "relative" }}
              >
                {t("See “Attention” alerts")}
              </Link>
            </>
          }
        />
      ) : null}

      {isAdmin && (
        <Title level={3} style={{ textAlign: "left" }}>
          {t("Alerts")}
        </Title>
      )}

      <Flex gap={!isMobile ? 24 : 8}>
        {statisticData.map((el, id) => (
          <FilterCard
            key={el.name}
            data={{
              ...el,
              value: statistics?.[el.id?.toLowerCase()],
              isConnected: statistics?.[el.id] !== null || el.name === "All" || isAdmin,
              status: id ? enrollments[id - 1]?.connection_status : null
            }}
            isActive={filters?.alert_service?.includes(el.id)}
            onClick={handleSelectEnrollment}
            isAdmin={isAdmin}
            theme={theme}
            isMobile={isMobile}
          />
        ))}
      </Flex>

      {!isMobile && <Divider style={{ margin: 0 }} />}

      {isBulkActionActive ? (
        <Flex align="center" gap={16}>
          <Text type="secondary" strong>
            Bulk action
          </Text>
          <Button disabled={bulkStatusUpdateDisabled} onClick={onBulkStatusUpdate}>
            Set status of all selected alerts to “Auto-refunded”
          </Button>
          <Button style={{ marginLeft: "auto" }} onClick={cancelBulkAction}>
            Close bulk action
          </Button>
        </Flex>
      ) : (
        <Flex
          gap={isMobile ? 0 : 32}
          align="center"
          justify="space-between"
          style={{ margin: "-4px 0 0" }}
        >
          <Filters
            visibleFilters={visibleFilters}
            filterOptions={filterOptions}
            allFilters={allFilters}
            filters={filters}
            onChangeFilter={handleChangeFilter}
            showClearBtn={!isFiltersDefault}
            onClearFilters={onClear}
            addGlobalFilter={props.addGlobalFilter}
            removeGlobalFilter={props.removeGlobalFilter}
            isMobile={isMobile}
          />

          <Space style={{ flexShrink: 0 }}>
            <GlobalFilterTestData usersViewForAdmin={usersViewForAdmin} />

            {!isMobile && isAdminPage && (
              <Segmented
                options={optionsVisibility}
                value={filters?.["user_visibility"]}
                onChange={(value) => handleChangeFilter({ user_visibility: value })}
              />
            )}
            {!isMobile && !isAdminPage && (
              <Segmented
                options={userOptionsBillable}
                value={filters?.["billable"]}
                onChange={(value) => handleChangeFilter({ billable: value })}
              />
            )}

            <ExportDropdown
              loading={exportFetching}
              onExport={(type) => handleExport(type)}
              isAdmin={isAdminPage}
              disabled={isDemo}
              exportAsFiltered={true}
              iconButton={isMobile}
            />

            {!isMobile && activeAlertsViewMode === "table" && (
              <ManageColumn
                myColumns={myColumns}
                onChangeColumns={(newColumns) => handleChangeColumns(newColumns)}
                disabled={isDemo}
                dataTour="alerts-table-manage-columns"
              />
            )}
            {isBulkActionEnabled && (
              <Button onClick={() => onBulkAction()} disabled={isBulkActionDisabled}>
                Bulk Action
              </Button>
            )}
            {!isMobile && (
              <ListViewToggle view={activeAlertsViewMode} setView={handleSetAlertsViewMode} />
            )}
          </Space>
        </Flex>
      )}

      {(effectiveViewMode === "table" || isBackgroundReady) && (
        <div style={{ display: effectiveViewMode === "table" ? "block" : "none" }}>
          <Table
            columns={displayedTableColumns}
            loading={fetching}
            dataSource={displayedTableData}
            scroll={tableSettings.scroll}
            onChange={handleChangeTable}
            pagination={tableSettings.pagination}
            showSizeChanger={false}
            //withOutPagination={true}
            locale={tableSettings.locale}
            rowHoverable={true}
            headerDataTour="alerts-table-header"
            onRow={
              isTableEnhanced
                ? (record) => ({
                    onClick: () => {
                      openAlertDetails(record)
                    }
                  })
                : undefined
            }
            rowSelection={isTableEnhanced && isBulkActionEnabled ? rowSelection : null}
            rowKey={"alert_id"}
            className="alerts-table"
          />
        </div>
      )}

      {(effectiveViewMode === "cards" || isBackgroundReady) && (
        <Flex
          vertical
          style={{ display: effectiveViewMode === "cards" ? "block" : "none" }}
          gap={16}
        >
          <AlertsList
            data={results ?? []}
            handleSelectRow={handleSelectRow}
            handleChangeStatus={handleChangeStatus}
            loading={fetching}
            emptyComponent={<EmptyComponent type={isAdmin ? "alerts_admin" : "alerts"} />}
            disabledStatus={
              businessAccountRole && !extendedAccessRoles?.includes(businessAccountRole)
            }
          />
          {results?.length > 0 &&
            (isMobile ? (
              <MobilePagination
                current={pageNumber}
                total={count || 0}
                pageSize={pageSize}
                onChange={(page) => setPageNumber(page)}
              />
            ) : (
              <div className="custom-table" style={{ marginBottom: "15px" }}>
                <Pagination
                  rootClassName={"ant-table-pagination ant-table-pagination-left"}
                  onChange={(page) => setPageNumber(page)}
                  position={["none", "bottomLeft"]}
                  total={count || 0}
                  pageSize={pageSize}
                  current={pageNumber}
                  showLessItems={true}
                  showTotal={(total, range) => (
                    <Text>
                      Showing <Text strong>{`${range[0]}-${range[1]} of ${total}`}</Text> results
                    </Text>
                  )}
                  itemRender={(_, type, originalElement) =>
                    pageSize >= count ? null : itemRender(_, type, originalElement, t)
                  }
                  showSizeChanger={false}
                  showQuickJumper={false}
                />
              </div>
            ))}
        </Flex>
      )}

      <Modal
        title="Congratulations on your first chargeback prevented with RDR! 🎉"
        closeIcon={<Icon type="cross_small" style={{ color: "#7A7A83" }} />}
        centered={!isMobile}
        classNames={{ content: "clear-bg" }}
        onCancel={handleModalClose}
        open={isRdrModalVisible}
        onOk={handleModalClose}
        okButtonProps={{
          size: "large"
        }}
        okText="Done"
        cancelButtonProps={{ style: { display: "none" } }}
        width={442}
      >
        <Text type="secondary">
          {t("RDR works a little differently, so let’s break it down:")}
          <br />
          <br />
          {t("When you receive an RDR alert, it will show up as")}
          <Text type="secondary" style={{ fontWeight: "bold" }}>
            {t(` "Dispute Lost" `)}
          </Text>
          {t("in your payment processor. However, these alerts")}
          <Text type="secondary" style={{ fontWeight: "bold" }}>
            {t(" do not impact your dispute rate.")}
          </Text>
        </Text>
        <Carousel dotActiveWidth="24" dotGap="8" dotWidth="6" dots dotHeight="6" draggable>
          <img src={Images.rdrPopUpFirstImage} alt="" />
          <img src={Images.rdrPopUpSecondImage} alt="" />
        </Carousel>
        <div style={{ marginTop: "12px" }}>
          <Text type="secondary" strong>
            This means they won’t cause any issues with your payment processor, keeping your account
            in good standing. For more information, check out this{" "}
            <Link
              href="https://help.chargeback.io/en/articles/12782851-why-rdr-alerts-result-in-lost-chargebacks"
              target="_blank"
              style={{ textDecoration: "underline", color: "blue" }}
            >
              resource.
            </Link>
          </Text>
        </div>
      </Modal>
      <AlertDrawer
        isDemo={isDemo}
        isDemoModeBlocked={isDemoModeBlocked}
        //TODO: CHA-6795
        // onOpenTransactionModal={canOpenTransactionModal ? openTransactionModal : null}
        // onSubmitAlertStatusChange={submitAlertStatusChange}
        onOpenTransactionModal={null}
        onSubmitAlertStatusChange={({ alert, newStatus }) =>
          props.updateAlert({ alert_id: alert?.alert_id, alert_status: newStatus })
        }
      />

      {/* {!isAdmin && <FeedbackModal count={count_not_demo} />} */}

      <TourComponent
        open={demoTourStep === 2 && isDemo}
        steps={steps}
        onClose={() => props.setDemoTourStep(null)}
      />
      {/* //TODO: CHA-6795
      <TransactionModal
        open={!!transactionModalAlert}
        onClose={closeTransactionModal}
        onSave={saveTransactionModalData}
        initialValue={transactionModalInitialValue}
        saving={transactionModalSaving}
        error={transactionModalError}
        onClearError={props.clearTransactionModalError}
        status={transactionModalAlert?.alert_status}
        connectedProcessors={transactionModalProcessors}
      />
      */}
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  businessAccountId: state.auth.userInfo.current_business_account_id,
  roleId: state.auth.userInfo?.role?.id,
  ba_role: state.auth.userInfo?.ba_role?.id,
  is_demo: state.auth.userInfo?.is_demo,
  showRdrPopUp: state.auth.userInfo?.is_rdr_popup_shown,
  currentBusinessAccountId: state.auth.userInfo?.current_business_account_id,
  isAdmin: state.auth.isAdmin,
  nav: state.nav,
  visibleFiltersUser: state.alerts.visibleFilters,
  visibleFiltersAdmin: state.alerts.visibleFiltersAdmin,

  defaultColumns: state.alerts.defaultColumns,
  defaultColumnsAdmin: state.alerts.defaultColumnsAdmin,
  enrollments: state.user.enrollments,
  columns: state.alerts.columns,
  columnsAdmin: state.alerts.columnsAdmin,

  fetching: state.alerts.fetching,
  result: state.alerts.result,

  filters: state.alerts.filters,
  filterOptions: state.alerts.filterOptions,
  test_data: state.globalFilters.testData,

  exportFetching: state.alerts.exportFetching,
  exportResult: state.alerts.exportResult,

  saveResult: state.alerts.saveResult,
  transactionModalSaving: state.alerts.transactionModalSaving,
  transactionModalError: state.alerts.transactionModalError,
  demoTourStep: state.user.demoTourStep,

  alertsViewMode: state.alerts.alertsViewMode
})

const mapDispatchToProps = (dispatch) => ({
  getAlertsFilterOptions: (params) => dispatch(Creators.getAlertsFilterOptionsRequest(params)),
  getAlertsStatistics: (params) => dispatch(Creators.getAlertsStatisticsRequest(params)),
  getEnrollments: (businessAccountId) => dispatch(getEnrollments(businessAccountId)),
  getAlerts: (params) => dispatch(Creators.getAlertsRequest(params)),
  getPaymentProcessors: (data) => dispatch(getPaymentProcessors(data)),
  updateAlert: (params) => dispatch(Creators.updateAlertRequest(params)),
  updateAlertTransaction: (params) => dispatch(Creators.updateAlertTransactionRequest(params)),
  pinAlert: (params) => dispatch(Creators.pinAlertRequest(params)),
  getAlertsExport: (data) => dispatch(Creators.getAlertsExportRequest(data)),
  clearExportResult: () => dispatch(Creators.alertsSetProp("exportResult", null)),
  changeColumns: (key, columns) => dispatch(Creators.alertsSetProp(key, columns)),
  changeFilters: (filters) => dispatch(Creators.alertsSetProp("filters", filters)),
  changeVisibleFilters: (visibleFiltersType, filters) =>
    dispatch(Creators.alertsSetProp(visibleFiltersType, filters)),
  clearAlertsFilters: () => dispatch(Creators.clearAlertsFilters()),
  saveResultReset: () => dispatch(Creators.alertsSetProp("saveResult", null)),
  clearTransactionModalError: () => dispatch(Creators.alertsSetProp("transactionModalError", null)),

  clearGlobalFilters: () => dispatch(GlobalCreators.clearGlobalFilters()),
  addGlobalFilter: (key, value) => dispatch(GlobalCreators.addGlobalFilter(key, value)),
  removeGlobalFilter: (key) => dispatch(GlobalCreators.removeGlobalFilter(key)),
  updateUser: (data) => dispatch(userSave(data)),
  setDemoTourStep: (step) => dispatch(setDemoTourStep(step)),
  setAlertsViewMode: (mode) => dispatch(Creators.alertsSetProp("alertsViewMode", mode))
})

export default connect(mapStateToProps, mapDispatchToProps)(AlertsPage)
